module.exports = __webpack_public_path__ + "static/media/MarvelApp.08265a0c.png";